// @ts-nocheck ts(2834)

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Component loaders for dynamic imports
 * All components are lazy-loaded to optimize bundle size
 */

// Priority components (above-the-fold) - will be preloaded immediately
export const PRIORITY_PRELOAD_COMPONENTS = new Set([
    "page",
    "globalNav",
    "globalFooter",
    "heroSection",
    "heroIntro",
    "heroCarousel",
    "heroCarouselSection",
    "customerStoriesDetailsHero",
    "container", // Often wraps above-the-fold content
    "heading", // Critical for LCP - headings are typically above-the-fold
    "text" // Often critical content that affects LCP,
]);

// Dynamic component loaders - ALL components are lazy loaded (alphabetical order)
export const componentLoaders: Record<string, () => Promise<any>> = {
    accordion: () => import("./components/accordion"),
    bannerAlert: () => import("./components/banner-alert"),
    bodyContentV1: () => import("./components/body-content-v1"),
    button: () => import("./components/button"),
    callToAction: () => import("./components/call-to-action"),
    card: () => import("./components/card"),
    columnLayout: () =>
        import("./components/column-layout").then((m) => ({
            default: m.UniformColumnLayout
        })),
    container: () => import("./components/container"),
    contentBlock: () => import("./components/content-block"),
    customerStat: () => import("./components/customer-stat"),
    customerStoriesDetailsHero: () =>
        import("./components/customer-stories-details-hero"),
    customerTestimonials: () => import("./components/customer-testimonials"),
    globalFooter: () => import("./components/global-footer"),
    globalNav: () => import("./components/global-nav"),
    heading: () => import("./components/heading"),
    heroCarousel: () => import("./components/hero-carousel-v0"),
    heroCarouselSection: () => import("./components/hero-carousel"),
    heroIntro: () => import("./components/hero-intro"),
    heroSection: () => import("./components/hero-section"),
    horizontalDivider: () => import("./components/horizontal-divider"),
    image: () => import("./components/image"),
    jiraTemplatesTabContentSubgridLayout: () =>
        import("./components/jira-templates-tab-content-subgrid-layout"),
    link: () => import("./components/link"),
    list: () => import("./components/list"),
    listv2: () => import("./components/listv2"),
    lozenge: () => import("./components/lozenge"),
    modal: () => import("./components/modal"),
    page: () => import("./components/page"),
    pagination: () => import("./components/pagination"),
    personalizationContainer: () =>
        import("./components/personalization-container"),
    pricingCalculator: () => import("./components/pricing-calculator"),
    pricingTable: () => import("./components/pricing-table"),
    productCard: () => import("./components/product-card"),
    pullQuote: () => import("./components/pull-quote"),
    singleTab: () => import("./components/single-tab"),
    splitColorBackgroundContainer: () =>
        import("./components/split-color-background-container"),
    statsSection: () => import("./components/stats-section"),
    statsigExperimentContainer: () => import("./components/experiment"),
    statsigFeatureGateContainer: () => import("./components/feature-gate"),
    subColumnLayout: () =>
        import("./components/column-layout").then((m) => ({
            default: m.UniformSubColumnLayout
        })),
    tabs12Col: () => import("./components/tabs-12-col"),
    tabs8Col: () => import("./components/tabs-8-col"),
    templateModalButton: () => import("./components/template-modal-button"),
    templatePreview: () => import("./components/template-preview"),
    text: () => import("./components/text"),
    textWithIcon: () => import("./components/text-with-icon"),
    variant: () => import("./components/variant"),
    variantContainer: () => import("./components/variant-container")
};

// Mapping from Uniform component types to internal loader keys (alphabetical order)
export const UNIFORM_TYPE_TO_LOADER: Record<string, string> = {
    accordion: "accordion",
    bannerAlert: "bannerAlert",
    blockContainer: "container", // Legacy alias
    button: "button",
    card: "card",
    columnLayout: "columnLayout",
    container: "container",
    contentBlock: "contentBlock",
    ctaWithPolygonBackground: "callToAction",
    customerBodyContent: "bodyContentV1",
    customerStat: "customerStat",
    customerStoriesDetailsHero: "customerStoriesDetailsHero",
    customerTestimonials: "customerTestimonials",
    globalFooter: "globalFooter",
    globalNav: "globalNav",
    heading: "heading",
    heroCarousel: "heroCarousel", // Maps to hero-carousel-v0
    heroCarouselSection: "heroCarouselSection", // Maps to hero-carousel
    heroIntro: "heroIntro",
    heroSection: "heroSection",
    horizontalDivider: "horizontalDivider",
    image: "image",
    jiraTemplatesTabContentSubgridLayout:
        "jiraTemplatesTabContentSubgridLayout",
    link: "link",
    list: "list",
    listv2: "listv2",
    lozenge: "lozenge",
    modal: "modal",
    page: "page",
    pagination: "pagination",
    personalizationContainer: "personalizationContainer",
    pricingCalculator: "pricingCalculator",
    pricingTable: "pricingTable",
    productCard: "productCard",
    pullQuote: "pullQuote",
    singleTab: "singleTab",
    splitBackgroundContainer: "splitColorBackgroundContainer",
    statsSection: "statsSection",
    statsigExperimentContainer: "experiment",
    statsigFeatureGateContainer: "featureGate",
    subColumnLayout: "subColumnLayout",
    tabs12Col: "tabs12Col",
    tabs8Col: "tabs8Col",
    templateModalButton: "templateModalButton",
    templatePreview: "templatePreview",
    text: "text",
    textWithIcon: "textWithIcon",
    variant: "variant",
    variantContainer: "variantContainer"
};
